import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../other/AuthContext';
import Specific from '../pieces/home-pieces/Specific';
import Consolidated from '../pieces/home-pieces/Consolidated';
import Headertab from '../pieces/global/Headertab';
import WorkoutDuration from '../charts/WorkoutDuration';
import Volume from '../charts/Volume';
import OneRepMax from '../charts/OneRepMax';
import PersonalRecord from '../charts/PersonalRecord';
import BestSetVolume from '../charts/BestSetVolume';
import RepCount from '../charts/RepCount';
import Sidebar from '../pieces/global/Sidebar';




const Home = () => {


  const navigate = useNavigate();

  //sidebar
  const [SidebarTab, setSidebarTab] = useState('Dashboar');

  //These are set from Control Component
  const [ActiveMuscle, setActiveMuscle] = useState('Chest');
  const [ActiveExcercise, setActiveExcercise] = useState('Incline Bench Press (Dumbbell)');


  //Dropdowns
  const [ExcerciseDropdown, setExcerciseDropdown] = useState([]);


  const [MasterTab, setMasterTab] = useState('Specific');
  const [ActiveTab, setActiveTab] = useState();
  const [ActiveDropdown, setActiveDropdown] = useState();



  const FROM_DATETIME_TO_LOAD = '2023-06-08T02:03:00.000Z';
  const TO_DATETIME_TO_LOAD = '2025-01-14T06:46:00.000Z';

  //Date range for charts
  const [dateRangeStart, setDateRangeStart] = useState(FROM_DATETIME_TO_LOAD);
  const [dateRangeEnd, setDateRangeEnd] = useState(TO_DATETIME_TO_LOAD);
  const [ActiveDateRange, setActiveDateRange] = useState('6m');


  const { user, logoutUser } = useAuth();






  //useEffect
  useEffect(() => {


  }, []);




  //#region HANDLE CHANGES ---------------------------------------------------------------------------------------------------------




  const handleLogout = (e) => {
    e.preventDefault();
    logoutUser();
  };



  const navigateto = (where) => {
    navigate(where);
  };






  //#endregion HANDLE CHANGES ---------------------------------------------------------------------------------------------------------




  return (

    <div>
     

      <div className='home-layout'>


        <Sidebar />




        <div className='content-container' >
        <Headertab ActiveTab='Home' handleLogout={handleLogout} navigateto={navigateto} user={user} />



          <div >

            <div className='controls-container'>



            </div >


            {ActiveMuscle !== 'overall' ?

              < Specific >


                <div className="max_width">


                  <div className='chart-container'>



                    <RepCount dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                    <BestSetVolume dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                    <PersonalRecord dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                    <OneRepMax dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                    <Volume dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                    <WorkoutDuration dateRangeStart={dateRangeStart} dateRangeEnd={dateRangeEnd} ActiveExcercise={ActiveExcercise} />

                  </div>




                </div>

              </Specific>

              :

              <Consolidated >

                <div className='max_width'>
                  Hello this is consolidated
                </div>



              </Consolidated>

            }



          </div>

        </div>




      </div>



















    </div>
  );
};

export default Home;
